import  * as mode from './PageMode'
import  * as url from './route_url'
import  * as pageId from './allPageID'

export {mode,url,pageId}